import * as React from "react";
import { omitBy } from "lodash-es";
import { casesActions } from "configs";
import {
  FormWatcherCallback,
  resolveString,
  useCurrentCase,
  useDispatch,
  useParams
} from "duck";
import { useUpdateTploMutation } from "requests";
import { FormValues } from "./types";

export const useUpdateTplo = (tploId: number | string | null) => {
  const dispatch = useDispatch();
  const { id: caseId } = useParams();
  const shouldSync = useCurrentCase(medicalCase => medicalCase.shouldSync);
  const [update] = useUpdateTploMutation({ ignoreResults: true });

  return React.useCallback<FormWatcherCallback<FormValues>>(
    values => {
      if (!tploId) {
        return;
      }

      const input = omitBy(
        {
          d1: resolveString(values.d1),
          d2: resolveString(values.d2),
          d3: resolveString(values.d3),
          rotationNeeded: resolveString(values.rotationNeeded),
          initialTpa: resolveString(values.initialTpa),
          postOpTpa: resolveString(values.postOpTpa),
          tploBladeSize: resolveString(values.tploBladeSize),
          tploPlateSizeAndModel: resolveString(values.tploPlateSizeAndModel)
        },
        value => value === undefined
      );

      dispatch(
        casesActions.updateTPLO({
          _id: caseId,
          data: {
            ...input,
            ...(typeof tploId === "number"
              ? { _id: tploId }
              : { fakeId: tploId })
          }
        })
      );

      if (shouldSync && typeof tploId === "number") {
        return update({ variables: { input: { ...input, _id: tploId } } });
      }
    },
    [tploId, update]
  );
};
